module.exports = __webpack_public_path__ + "img/262.a0f215cb.jpg";